import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import SlickSlider from "react-slick";

import BannerService from '../../../../services/Banner';

import loadImage from "../../../../utils/LoadImage";

import SliderPlaceholder from "../../../../assets/images/placeholders/slider-996-494.png";

import { AditionalContent, Title, Text } from "./styles";

function Slider() {
    const [banners, setbanners] = useState([]);
    const history = useHistory();

    const params = {
        dots: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 6000,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: true,
        adaptiveHeight: false
    };

    const handleListBanners = useCallback(() => {
        const bannerService = new BannerService();

        bannerService.listByCompany().then((response) => {
            setbanners(response.data.payload);
        });
    }, []);

    useEffect(() => {
        handleListBanners();
    }, [handleListBanners]);


    const goToLink = (link) => {
        if (link) {
            if (link.indexOf('http') === -1 && link.indexOf('.com') === -1 && link.indexOf('www.') === -1) {
                history.push({ pathname: link, search: history.location.search });
            } else {
                if (link.indexOf('http') === -1) {
                    window.location.href = 'https://' + link;
                } else {
                    window.location.href = link;
                }
            }
        }
    }

    return (
        <SlickSlider {...params} className="MainHome ReactSlick">
            {banners && banners.map((banner) => {
                return banner.imagens.map((item) => (
                    <div className="WrapperSliderItem">
                        <div class="WrapAnchorPicture">

                            <a href="#!" onClick={() => goToLink(item.link)} className="slider-item" key={item.imagem}>
                                <div className="WrapPicture">
                                    <picture>
                                        <LazyLoadImage
                                            onError={(e) => e.target.src = SliderPlaceholder}
                                            src={loadImage({ imageCode: item.imagem })}
                                            alt="Scamb"
                                        />
                                    </picture>
                                </div>
                            </a>
                        </div>
                        {item.titulo && (
                            <AditionalContent >
                                <Title>{item.titulo}</Title>
                                <Text>
                                    {item.descricao}
                                </Text>
                            </AditionalContent>
                        )}
                    </div>
                ))
            })}
        </SlickSlider>
    )
}

export default Slider;